export const SELF_PICKUP = 'SELF_PICKUP';
